import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { AdminShell } from "./routes/AdminShell";
import { DashboardPage } from "./modules/dashboard/DashboardPage";
import { PrioritiesPage } from "./modules/dashboard/PrioritiesPage";
import { BlogListPage } from "./modules/blog/BlogListPage";
import { BlogEditorPage } from "./modules/blog/BlogEditorPage";
import { LeadsPage } from "./modules/leads/LeadsPage";
import { DirectoryPage } from "./modules/directory/DirectoryPage";
import { BillingPage } from "./modules/directory/BillingPage";
import { StoreEditPage } from "./modules/directory/StoreEditPage";
import { Store360Page } from "./modules/directory/Store360Page";
import { DirectoryProfileReportsPage } from "./modules/directory/DirectoryProfileReportsPage";
import { ContentListPage } from "./modules/content/ContentListPage";
import { ContentEditorPage } from "./modules/content/ContentEditorPage";
import { MediaPage } from "./modules/media/MediaPage";
import { SettingsPage } from "./modules/settings/SettingsPage";

const queryClient = new QueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              element={
                <ProtectedRoute>
                  <AdminShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="/dashboard" element={<Navigate to="/" replace />} />
              <Route path="/prioridades" element={<PrioritiesPage />} />
              <Route path="/paginas" element={<ContentListPage section="paginas" />} />
              <Route path="/paginas/:id" element={<ContentEditorPage section="paginas" />} />
              <Route path="/servicios" element={<ContentListPage section="servicios" />} />
              <Route path="/servicios/:id" element={<ContentEditorPage section="servicios" />} />
              <Route path="/planes" element={<ContentListPage section="planes" />} />
              <Route path="/planes/:id" element={<ContentEditorPage section="planes" />} />
              <Route path="/portafolio" element={<ContentListPage section="portafolio" />} />
              <Route path="/portafolio/:id" element={<ContentEditorPage section="portafolio" />} />
              <Route path="/casos" element={<ContentListPage section="casos" />} />
              <Route path="/casos/:id" element={<ContentEditorPage section="casos" />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:id" element={<BlogEditorPage />} />
              <Route path="/categorias" element={<ContentListPage section="categorias" />} />
              <Route path="/categorias/:id" element={<ContentEditorPage section="categorias" />} />
              <Route path="/faqs" element={<ContentListPage section="faqs" />} />
              <Route path="/faqs/:id" element={<ContentEditorPage section="faqs" />} />
              <Route path="/media" element={<MediaPage />} />
              <Route path="/media/:id" element={<ContentEditorPage section="media" />} />
              <Route path="/leads" element={<LeadsPage />} />
              <Route path="/directorio" element={<DirectoryPage />} />
              <Route path="/directorio/saas" element={<DirectoryPage originView="saas" />} />
              <Route path="/directorio/manuales" element={<DirectoryPage originView="manual" />} />
              <Route path="/directorio/:id" element={<Store360Page />} />
              <Route path="/reportes-fichas" element={<DirectoryProfileReportsPage />} />
              <Route path="/solicitudes" element={<DirectoryPage section="submissions" />} />
              <Route path="/invitaciones" element={<DirectoryPage section="invitations" />} />
              <Route path="/cobros" element={<BillingPage />} />
              <Route path="/directorio/:id/editar" element={<StoreEditPage />} />
              <Route path="/configuracion" element={<SettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
